module.exports = __webpack_public_path__ + "img/circle-today.4b3c5b60.svg";